import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { List, X, ArrowUpRight } from "@phosphor-icons/react";
import Logo from "@/components/brand/Logo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/drivers", label: "Drive" },
  { to: "/pros", label: "Pros" },
  { to: "/partners", label: "Partners" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-black/60 backdrop-blur-xl border-b border-ih-line"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 h-16 flex items-center justify-between">
        <div className="flex items-center gap-10">
          <Logo />
          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `px-3 py-1.5 text-sm font-medium rounded-md transition ${
                    isActive
                      ? "text-white bg-white/[0.06] border border-ih-line"
                      : "text-white/60 hover:text-white hover:bg-white/[0.04]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/drivers"
            data-testid="header-cta-driver"
            className="text-sm font-medium text-white/80 hover:text-ih-neon transition"
          >
            Become a Driver
          </Link>
          <Link
            to="/partners"
            data-testid="header-cta-partner"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white text-black text-sm font-semibold hover:scale-[1.02] hover:bg-ih-neon transition"
          >
            Partner With Us <ArrowUpRight weight="bold" size={14} />
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 rounded-md border border-ih-line text-white"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} weight="bold" /> : <List size={20} weight="bold" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-ih-line bg-ih-ink/95 backdrop-blur-xl">
          <nav className="px-5 py-4 flex flex-col gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-base font-medium ${
                    isActive ? "bg-white/[0.06] text-white" : "text-white/70"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <div className="h-px bg-ih-line my-3" />
            <Link
              to="/drivers"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-driver"
              className="px-3 py-2.5 rounded-md text-base font-medium text-ih-neon"
            >
              Become a Driver →
            </Link>
            <Link
              to="/partners"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-partner"
              className="px-3 py-2.5 rounded-md text-base font-semibold bg-white text-black text-center"
            >
              Partner With Us
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
